/**
 * Group Form Component Types
 */

import { z } from 'zod';

/**
 * Group Form Validation Schema with Zod
 */
export const groupFormSchema = z.object({
  organizationId: z
    .number({
      required_error: 'Selecione uma organização',
      invalid_type_error: 'Selecione uma organização válida',
    })
    .int('Organização inválida')
    .positive('Selecione uma organização'),
  
  name: z
    .string()
    .min(1, 'Nome é obrigatório')
    .min(2, 'Nome deve ter no mínimo 2 caracteres')
    .max(100, 'Nome deve ter no máximo 100 caracteres')
    .trim(),
  
  description: z
    .string()
    .max(500, 'Descrição deve ter no máximo 500 caracteres')
    .optional()
    .or(z.literal('')),
  
  status: z.enum(['active', 'inactive'], {
    errorMap: () => ({ message: 'Status inválido' }),
  }),
});

/**
 * Infer TypeScript type from schema
 */
export type GroupFormData = z.infer<typeof groupFormSchema>;

export interface GroupFormProps {
  /**
   * Initial form values for editing
   */
  initialValues?: Partial<GroupFormData>;

  /**
   * Form mode
   */
  mode: 'create' | 'edit';

  /**
   * Submit callback
   */
  onSubmit: (data: GroupFormData) => void | Promise<void>;

  /**
   * Cancel callback
   */
  onCancel: () => void;

  /**
   * Loading state
   */
  isLoading?: boolean;
}
